import type { Lead } from '@up2stay/up2promo-api-client';
import {
  findLeadDuplicateMatches,
  type LeadDuplicateCandidate,
  type LeadDuplicateMatchReason,
} from '@up2stay/up2promo-commons';

export type { LeadDuplicateMatchReason };

export interface LeadDuplicateMatch {
  lead: Lead;
  reasons: LeadDuplicateMatchReason[];
}

export type { LeadDuplicateCandidate };

/** Finds workspace leads that share contact data with the incoming candidate. */
export function findLeadDuplicates(
  existingLeads: Lead[],
  candidate: LeadDuplicateCandidate,
): LeadDuplicateMatch[] {
  return findLeadDuplicateMatches(existingLeads, candidate).map((hit) => ({
    lead: hit.item,
    reasons: hit.reasons,
  }));
}
